// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__a763c7e080e495c61913","cls2":"SimplePaperPodcast-cls2___91223fccf69db9e3f35 SimplePaperPodcast-cls1__a763c7e080e495c61913"};